module.exports = "/assets/c3f7cfe980785fbfab5c458f813c79ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PA.png
// module id = 2833
// module chunks = 0